<template>
  <div class="main">
    <div class="header">
      <Header id="navbar"></Header>
    </div>
    <div class="content" @scroll="handleScroll">
      <router-view></router-view>
    </div>
    <!-- <right-tool  v-if="pageWidth >= 780"></right-tool> -->
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import RightTool from "@/components/RightTool";
import {mapState, mapMutations} from "vuex";
import {wxRegister} from '@/libs/wxRegister'

export default {
  components: {
    Header,
    RightTool,
  },
  created() {
    // 通过ua标识判断
    // var userAgent = navigator.userAgent.toLowerCase() // 获取UA信息
    // if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
    this.wxInit()
    // }
  },
  computed: {

    pageWidth() {
      return window.innerWidth;
    }
  },
  methods: {
    ...mapMutations(["scrollTopChange"]),
    handleScroll(event) {
      this.scrollTopChange(event.target.scrollTop);
    },
    wxInit() {
      // 分享操作
      wxRegister(true, {
        proTitle: '晨新医疗',
        proDesc: '专注微创，晨新致远',
        proImg: 'https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/publicImg/cnew_share_img.png'
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  position: relative;

  .header {
    width: 100%;
    height: 110px;
    position: fixed;
    z-index: 999;
  }


  .content {
    padding-top: 110px;
    width: 100%;
    height: calc(100%);
    // overflow-y: scroll;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/main.vue